import { HugeiconsIcon } from "@hugeicons/react";
import { Modal } from "shared/components/Modal";
import { InformationCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import { Button, ButtonVariant } from "shared/components/Button";
import { useMutation } from "@tanstack/react-query";
import { instance } from "api/apiBase";
import { CombinedIncomeSubStep } from "../../../constants";
import { toast } from "react-toastify";
import { getErrorMessage } from "utils/error";
import { useCombinedIncome } from "../context";

interface SkipDocumentVerificationModalProps {
  opened: boolean;
  onClose: () => void;
}

const SkipDocumentVerificationModal = ({
  opened,
  onClose
}: SkipDocumentVerificationModalProps) => {
  const {
    applicationId,
    applicantId,
    verification,
    stepData,
    updateStepMutation
  } = useCombinedIncome();

  const skipDocumentVerification = useMutation({
    mutationKey: ["SKIP_DOCUMENT_VERIFICATION"],
    mutationFn: () => {
      return instance.post(
        `/portal/v1/applications/${applicationId}/verifications/${verification?.id}/income/${stepData.currentIncomeId}/skip_document_verification?applicant_id=${applicantId}`
      );
    },
    onSuccess: () => {
      updateStepMutation.mutate({
        lastStep: CombinedIncomeSubStep.AddAnotherIncome
      });
    },
    onError: (error) => {
      toast.error(
        getErrorMessage(error) || "Failed to skip document verification"
      );
    }
  });

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      panelClassName="w-full max-w-[366px] p-6 space-y-4"
    >
      <div className="h-16 w-16 mx-auto rounded-full bg-danger-50 p-4">
        <HugeiconsIcon
          icon={InformationCircleIcon}
          className="text-danger-500"
          size={32}
          strokeWidth={2}
        />
      </div>
      <div className="text-center space-y-2">
        <p className="text-xl font-bold text-content-1000">
          Do you want to skip document verification?
        </p>
        <p className="text-base text-content-500">
          If you skip this step, documents won’t be reviewed for fraud
        </p>
      </div>
      <div className="flex w-full gap-2">
        <Button className="w-full" onClick={onClose}>
          Cancel
        </Button>
        <Button
          className="w-full"
          variant={ButtonVariant.PRIMARY}
          onClick={() => skipDocumentVerification.mutate()}
        >
          Skip
        </Button>
      </div>
    </Modal>
  );
};

export default SkipDocumentVerificationModal;
